document.addEventListener('DOMContentLoaded', function() {
  var video = document.getElementById('myVideo');
  var playButton = document.querySelector('.video-popup__play');

  // Nascondi i controlli del video all'avvio
  video.removeAttribute('controls');

  // Gestisci l'evento di click sull'icona di play
  playButton.addEventListener('click', function() {
    video.play();
    playButton.style.display = 'none'; // Nascondi l'icona di play quando il video è in riproduzione
    video.setAttribute('controls', 'controls'); // Mostra i controlli del video solo quando il video è in riproduzione
  });

  // Gestisci l'evento di pausa del video
  video.addEventListener('pause', function() {
    playButton.style.display = 'flex'; // Mostra l'icona di play quando il video è in pausa
  });

  // Gestisci l'evento di riproduzione del video
  video.addEventListener('play', function() {
    playButton.style.display = 'none'; // Nascondi l'icona di play quando il video è in riproduzione
  });
});